// @ts-check

export const THEME_CACHE_PREFIX = "theme-cache:";
export const THEME_PREF_PREFIX = "theme-pref:";
export const THEME_CACHE_VERSION = 1;
export const THEME_READY_CLASS = "theme-ready";
export const THEME_CACHE_MAX_CHARS = 100000;

const VAR_NAME = /^--[a-z0-9-]+$/;
const HEX = /^#[0-9a-f]{6}$/;

/** @param {string} origin */
export function cacheKey(origin) {
  return `${THEME_CACHE_PREFIX}${origin}`;
}

/** @param {string} origin */
export function prefKey(origin) {
  return `${THEME_PREF_PREFIX}${origin}`;
}

/**
 * Writes or removes the preference immediately. Sign-out navigates in the same
 * click, before the theme effect can run, so the removal has to happen here.
 * @param {{ setItem: (key: string, value: string) => void, removeItem: (key: string) => void }} storage
 * @param {string} key
 * @param {string | null} localPref
 */
export function persistLocalPref(storage, key, localPref) {
  if (localPref) storage.setItem(key, localPref);
  else storage.removeItem(key);
}

/**
 * @param {string} themeId
 * @param {Record<string, string>} vars
 */
export function serialiseCache(themeId, vars) {
  return JSON.stringify({ v: THEME_CACHE_VERSION, themeId, vars });
}

/**
 * @param {unknown} text
 */
export function parseCache(text) {
  if (typeof text !== "string" || text.length === 0 || text.length > THEME_CACHE_MAX_CHARS) return null;
  /** @type {unknown} */
  let parsed;
  try {
    parsed = JSON.parse(text);
  } catch {
    return null;
  }
  if (!parsed || typeof parsed !== "object" || Array.isArray(parsed)) return null;
  const row = /** @type {Record<string, unknown>} */ (parsed);
  if (row.v !== THEME_CACHE_VERSION) return null;
  if (typeof row.themeId !== "string" || row.themeId === "") return null;
  if (!row.vars || typeof row.vars !== "object" || Array.isArray(row.vars)) return null;
  /** @type {Record<string, string>} */
  const vars = {};
  for (const [name, value] of Object.entries(row.vars)) {
    if (!Object.hasOwn(row.vars, name)) continue;
    if (!VAR_NAME.test(name) || typeof value !== "string" || !HEX.test(value)) return null;
    vars[name] = value;
  }
  if (Object.keys(vars).length === 0) return null;
  return { themeId: row.themeId, vars };
}
